/** Map backend trench MFA method names to settings UI keys. */
export const resolveActiveMfaMethod = mfaMethod => {
    if (mfaMethod === 'sms_twilio') return 'sms';
    if (mfaMethod === 'app') return 'app';
    return null;
};

export const resolveSetup2FAModalMethod = mfaMethod => {
    if (mfaMethod === 'sms_twilio') return 'sms';
    return 'qr';
};
